import { scrollElementToTopOfViewportIfNotVisible } from "../util/dom.js";
export var expandFaqEntry = function expandFaqEntry(faqEntry) {
  var isExpanded = faqEntry.classList.contains("faqEntry--is-expanded");
  if (isExpanded) {
    return;
  }
  var answer = faqEntry.querySelector(".answer");
  var answerHeight = answer.clientHeight;
  var _onTransitionEnd = function onTransitionEnd() {
    answer.removeEventListener("transitionend", _onTransitionEnd, false);
    scrollElementToTopOfViewportIfNotVisible(faqEntry);
  };
  answer.addEventListener("transitionend", _onTransitionEnd, false);
  answer.style.height = "0";
  setTimeout(function () {
    answer.style.height = "".concat(answerHeight, "px");
  }, 0);
  faqEntry.classList.add("faqEntry--is-expanded");
};
export var collapseFaqEntry = function collapseFaqEntry(faqEntry) {
  var isExpanded = faqEntry.classList.contains("faqEntry--is-expanded");
  if (!isExpanded) {
    return;
  }
  var answer = faqEntry.querySelector(".answer");
  var _onTransitionEnd2 = function onTransitionEnd() {
    answer.removeEventListener("transitionend", _onTransitionEnd2, false);
    answer.style.position = "";
    answer.style.height = "";
  };
  answer.addEventListener("transitionend", _onTransitionEnd2, false);
  answer.style.position = "static";
  answer.style.height = "0";
  faqEntry.classList.remove("faqEntry--is-expanded");
};